import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/_user/guards/auth.guard';
import { EmptyFocusComponent } from 'src/app/_core/components/empty-focus/empty-focus.component';
import { Layout } from 'src/app/_core/services/layout.service';

const routes: Routes = [
    {
        path: 'beneficiary',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/beneficiary/beneficiary.module').then(b => b.BeneficiaryModule)
    },
    {
        path: 'beneficiary',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/beneficiary/beneficiary.module').then(b => b.BeneficiaryModule)
    },
    {
        path: 'beneficiary',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/beneficiary/beneficiary.module').then(b => b.BeneficiaryModule)
    },
    {
        path: 'web-administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/web-administration/web-administration.module').then(m => m.WebAdministrationModule)
    },
    {
        path: 'web-administration',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/web-administration/web-administration.module').then(m => m.WebAdministrationModule)
    },
    {
        path: 'web-administration',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/web-administration/web-administration.module').then(m => m.WebAdministrationModule)
    },
    {
        path: 'system',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/system/system.module').then(m => m.SystemModule)
    },
    {
        path: 'system',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/system/system.module').then(m => m.SystemModule)
    },
    {
        path: 'system',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/system/system.module').then(m => m.SystemModule)
    },
    {
        path: 'activity',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/activity/activity.module').then(m => m.ActivityModule)
    },
    {
        path: 'activity',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/activity/activity.module').then(m => m.ActivityModule)
    },
    {
        path: 'activity',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/activity/activity.module').then(m => m.ActivityModule)
    },
    {
        path: 'contact',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/contact/contact.module').then(m => m.ContactModule)
    },
    {
        path: 'contact',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/contact/contact.module').then(m => m.ContactModule)
    },
    {
        path: 'contact',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/contact/contact.module').then(m => m.ContactModule)
    },
    {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/home/home.module').then(m => m.HomeModule)
    },
    {
        path: 'home',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/home/home.module').then(m => m.HomeModule)
    },
    {
        path: 'home',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/home/home.module').then(m => m.HomeModule)
    },
    {
        path: 'subvention',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/subvention/subvention.module').then(m => m.SubventionModule)
    },
    {
        path: 'subvention',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/subvention/subvention.module').then(m => m.SubventionModule)
    },
    {
        path: 'subvention',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/subvention/subvention.module').then(m => m.SubventionModule)
    },
    {
        path: 'accounting',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/accounting/accounting.module').then(m => m.AccountingModule)
    },
    {
        path: 'accounting',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/accounting/accounting.module').then(m => m.AccountingModule)
    },
    {
        path: 'accounting',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/accounting/accounting.module').then(m => m.AccountingModule)
    },
    {
        path: 'exports',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/exports/exports.module').then(m => m.ExportsModule)
    },
    {
        path: 'exports',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/exports/exports.module').then(m => m.ExportsModule)
    },
    {
        path: 'exports',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/exports/exports.module').then(m => m.ExportsModule)
    },
    {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/administration/administration.module').then(m => m.AdministrationModule)
    },
    {
        path: 'administration',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/administration/administration.module').then(m => m.AdministrationModule)
    },
    {
        path: 'administration',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/administration/administration.module').then(m => m.AdministrationModule)
    },
    {
        path: 'dev-tools',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/dev-tools/dev-tools.module').then(m => m.DevToolsModule)
    },
    {
        path: 'dev-tools',
        outlet: 'content',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/dev-tools/dev-tools.module').then(m => m.DevToolsModule)
    },
    {
        path: 'dev-tools',
        outlet: 'focus',
        canActivate: [AuthGuard],
        loadChildren: () => import('./board/dev-tools/dev-tools.module').then(m => m.DevToolsModule)
    },
    /**
     * Empty component to avoid "route not found" when refreshing url
     * with empty <code>(focus:)</code>
     */
    {
        path: 'empty',
        outlet: 'focus',
        data: {layout: Layout.Full},
        component: EmptyFocusComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
